<template>
  <div class="downlo">
    <div>
      Fazendo Download da evidencia <strong>{{ evidence.nomeArquivo }}</strong
      >...
    </div>
    <div class="d-flex">
      <div class="mr-1">
        Caso o download não tenha iniciado sozinho, por favor
      </div>
      <div class="clique" @click="download">Clique aqui</div>
    </div>
  </div>
</template>
<script>
import { administrativeDashboardAPI } from "@/modules/administrative-dashboard";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      evidence: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    getEvidencia() {
      administrativeDashboardAPI
        .getPerguntaEvidencia(this.$route.params.evidenceId)
        .then(({ data: evidence }) => {
          this.evidence = evidence;
          this.download();
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter download");
        });
    },
    download() {
      administrativeDashboardAPI
        .downloadRefusedEvidence(this.$route.params.evidenceId)
        .then((resp) => {
          console.log("resp: ", resp);
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = this.evidence.nomeArquivo;
          link.click();
          window.close();
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter download");
        });
    },
  },
  mounted() {
    this.setLoading(true);

    this.getEvidencia();
  },
};
</script>
<style scoped>
.downlo {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.clique {
  color: var(--corPrimaria);
  font-weight: bold;
  cursor: pointer;
}
</style>
